module.exports = __webpack_public_path__ + "img/16.64883ef3.svg";